import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/DynamicFieldsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

export type DynamicFieldOptionParamsType = {
  position: number;
  labelEn: string;
  labelDe: string;
  dynamicFieldUuid: string;
};

const createDynamicFieldOption = async (
  dynamicFieldOption: DynamicFieldOptionParamsType,
) => {
  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.dynamicFieldOptions(dynamicFieldOption.dynamicFieldUuid),
    buildSaveDynamicOptionParams(dynamicFieldOption),
  );

  return data;
};

export const useCreateDynamicFieldOption = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createDynamicFieldOption,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.dynamicOptionSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.DYNAMIC_FIELDS] });
    },
    onError: handleError,
  });
};

export function buildSaveDynamicOptionParams(
  dynamicOption: DynamicFieldOptionParamsType,
) {
  return {
    dynamic_option: {
      input_value_en: dynamicOption.labelEn,
      input_value_de: dynamicOption.labelDe,
      position: parseInt(dynamicOption.position.toString(), 10),
    },
  };
}
